import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    'fixedPricing',
    'fixedPriceField',
    'rangePriceFields',
    'minPrice',
    'maxPrice',
    'price'
  ]

  connect() {
    console.log("Service form controller connected")
    this.togglePriceFields()
  }

  togglePriceFields() {
    const isFixedPricing = this.fixedPricingTarget.value === 'true'
    
    if (isFixedPricing) {
      this.showFixedPricing()
    } else {
      this.showRangePricing()
    }
  }

  showFixedPricing() {
    this.fixedPriceFieldTarget.classList.remove("hidden")
    this.rangePriceFieldsTarget.classList.add("hidden")
    
    // Clear range fields
    if (this.hasMinPriceTarget) this.minPriceTarget.value = ''
    if (this.hasMaxPriceTarget) this.maxPriceTarget.value = ''
    
    // Make fixed price required
    if (this.hasPriceTarget) {
      this.priceTarget.setAttribute('required', 'required')
    }
    
    // Remove required from range fields
    if (this.hasMinPriceTarget) this.minPriceTarget.removeAttribute('required')
    if (this.hasMaxPriceTarget) this.maxPriceTarget.removeAttribute('required')
  }

  showRangePricing() {
    this.fixedPriceFieldTarget.classList.add("hidden")
    this.rangePriceFieldsTarget.classList.remove("hidden")
    
    // Clear fixed price field
    if (this.hasPriceTarget) this.priceTarget.value = ''
    
    // Make range fields required
    if (this.hasMinPriceTarget) this.minPriceTarget.setAttribute('required', 'required')
    if (this.hasMaxPriceTarget) this.maxPriceTarget.setAttribute('required', 'required')
    
    // Remove required from fixed price
    if (this.hasPriceTarget) {
      this.priceTarget.removeAttribute('required')
    }
  }
}